/*
 * @Author: cc
 * @LastEditTime: 2022-01-26 16:41:51
 */
import { useLocation } from "react-router-dom";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
// 获取url参数
export function getQueryVariable(variable: string) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}
// 判断设备类型
function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
// const getValueFromEvent = (e: any) => {
//   console.log(e.target.value);
//   return e.target.value.replace(/(^\s*)|(\s*$)/g, "");
// };
// function StartComponent(props: any) {
//   const { required } = props;
//   return (
//     <span
//       style={{ color: "red", width: "10px" }}
//       className={required ? "" : "hideStart"}
//     >
//       *
//     </span>
//   );
// }
export const isPc = IsPC();
